import { Fragment } from 'react'
import cx from 'classnames'
import { Row, Col, Card } from 'antd'
import _ from 'lodash'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { PROPOSAL_PHASE_TYPE, PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { HyperLink } from '../../../Common/Form'
import { ConnectedListingLink } from '../../../Common/ListingLink/ListingLink'
import styles from './index.css'
import { BATCH_PROPOSAL_TYPE } from '../../BatchUploadImage'
import { DATE_FORMAT } from '../../../../lib/MomentHelper'
import { UPDATE_LISTING_FORM_KEY, PROPOSAL_TYPE_NAME } from '../../../../constants/proposalTypes'
import { SECTION, FIELD } from '../ScheduledBlock'

export const getPrefix = (proposalType) => {
  return _.get(PROPOSAL_TYPE_NAME, proposalType, '預約')
}

const getBatchProposalLink = (batchId, type) => `/proposal/batch/${PROPOSAL_TYPE.UPDATE_IMAGE}/${PROPOSAL_PHASE_TYPE.OVERVIEW}?batchId=${batchId}&type=${type}`

const UpdatedListingsBatchCard = props => {
  const {
    proposalType,
    successBatchMap = [],
    failedBatchMap = [],
    listings,
    scheduled = {}
  } = props

  const PROPOSAL_TYPE_PREFIX_MAP = {
    EXECUTE: getPrefix(proposalType),
    REVERT: '回檔'
  }

  const {
    [FIELD.IS_SCHEDULED]: isScheduled,
    [FIELD.IS_REVERT]: isRevert,
    [FIELD.EXECUTE_TS]: executeTs,
    [FIELD.REVERT_TS]: revertTs
  } = scheduled
  const isInstantExecute = !isScheduled && isRevert

  const listingsBatches = _.get(listings, '0.batches', [])
  const listingsBatchesMap = _.mapKeys(listingsBatches, 'type')
  const revartBatches = _.map(successBatchMap)
  const executeBatches = _.map(listings, 'proposal')
  const faildBatches = _.map(failedBatchMap)
  return (
    <>
      {listingsBatches.map((listingsBatch, index) => {
        const isRevert = listingsBatch.type === BATCH_PROPOSAL_TYPE.REVERT
        const proposalTypePrefix = isRevert ? PROPOSAL_TYPE_PREFIX_MAP.REVERT : PROPOSAL_TYPE_PREFIX_MAP.EXECUTE
        const batchLink = getBatchProposalLink(_.get(listingsBatchesMap, `${listingsBatch.type}.id`), listingsBatch.type)
        const scheduledTime = isRevert ? revertTs : executeTs
        const successBatches = _.filter(isRevert ? revartBatches : executeBatches, batch => {
          return !_.isUndefined(_.get(batch, 'id'))
        })

        return (
          <Card
            key={index}
            className={cx(styles.updateListingTable)}
          >
            <Row
              type='flex'
              align='middle'
              justify='space-between'
              className={styles.batchInfo}
            >
              <Col span={8}>
                <p>
                  <span className={styles.highlight}>{proposalTypePrefix}</span>
                  提案資訊
                </p>
                <p className={styles.timeTip}>
                  {
                    (isInstantExecute && !isRevert)
                      ? '立即執行'
                      : `預計執行時間：${scheduledTime.format(DATE_FORMAT.SCHEDULE)}`
                  }
                </p>
              </Col>
              <Col span={8}>
                <span
                  className={cx(
                    styles.subTitle,
                    styles.counter
                  )}
                >
                  {`共 ${_.size(successBatches)} 筆`}
                </span>
                <p className={styles.subTitle}>
                  (點擊提案編號可檢視提案執行狀態)
                </p>
              </Col>
              <Col span={8}>
                <HyperLink
                  target='_blank'
                  href={batchLink}
                >
                  批次提案檢視
                </HyperLink>
              </Col>
            </Row>
            <Row
              type='flex'
              align='middle'
              justify='center'
              gutter={[0, 8]}
            >
              <div className={styles.batchContent}>
                {faildBatches.map(failedBatch => {
                  const listingId = _.get(failedBatch, 'params.listing.id')
                  return (
                    <Fragment
                      key={listingId}
                    >
                      <Col
                        span={24}
                        type='flex'
                        align='left'
                        justify='center'
                        className={styles.failed}
                      >
                        {PROPOSAL_TYPE_PREFIX_MAP.EXECUTE}
                        提案編號：失敗(圖片不符規定)、查看賣場：
                        <ConnectedListingLink targetListingId={listingId}>
                          {listingId}
                        </ConnectedListingLink>
                      </Col>
                    </Fragment>
                  )
                })}
                {successBatches.map(batch => {
                  const listingId = _.get(batch, 'listing.id')
                  const proposalId = _.get(batch, 'id')
                  return (
                    <Fragment
                      key={listingId}
                    >
                      <Col
                        span={24}
                        type='flex'
                        align='left'
                        justify='center'
                      >
                        {PROPOSAL_TYPE_PREFIX_MAP.EXECUTE}
                        提案編號：
                        <HyperLink
                          target='_blank'
                          href={`/proposal/${proposalType}/${PROPOSAL_PHASE_TYPE.OVERVIEW}?id=${proposalId}`}
                          data-role='proposal-id'
                        >
                          {proposalId}
                        </HyperLink>
                        、查看賣場：
                        <ConnectedListingLink targetListingId={listingId}>
                          {listingId}
                        </ConnectedListingLink>
                      </Col>
                    </Fragment>
                  )
                })}
              </div>
            </Row>
          </Card>
        )
      })}
      <div className={styles.listingQueryBlock}>
        <HyperLink
          target='_blank'
          href='/listing/query'
        >
          繼續修改其他賣場
        </HyperLink>
      </div>
    </>
  )
}

const selector = formValueSelector(UPDATE_LISTING_FORM_KEY)
const UpdatedListingsBatchCardForm = connect(state => {
  const scheduled = selector(state, SECTION) || {}
  return { scheduled }
})(UpdatedListingsBatchCard)

export default UpdatedListingsBatchCardForm
